// extracted by mini-css-extract-plugin
module.exports = {"detailsContainer":"_2ZJi8PkTqL63OzJLZabGwr","key":"_2wUDgtaxrbj6mFCRYTx6qI"};